export { PaymentPatreonPageContainer as PaymentPatreonPage } from "./container";
